import base from './base';
import components from './components';

export const theme = {
  ...base,
  components: { ...components }
};

export type Theme = typeof theme;

export type ThemeColors = typeof theme.colors;
